import axios, { AxiosStatic as HttpHandler } from 'axios';

const service = {
    axios
};
export default service;
export {
    axios,
    HttpHandler
};